export const COIN_GECKO = {
  API: {
    HOST: 'https://api.coingecko.com',
    PRICE_ENDPOINT: '/api/v3/simple/price?ids=',
    COIN_LIST_ENDPOINT: '/api/v3/coins/list?include_platform=true',
  },
}
